import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import EdiMonitoringContMain from "presentation/view/container/EdiMonitoring/ManualChargeContMain";

CommonEntrypoint(<EdiMonitoringContMain/>)